import {
  Component,
  Directive,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewEncapsulation,
  ViewChild,
} from '@angular/core';
import { IInboxJob } from '../../interfaces/inbox-job';
import { IInboxJobFilter } from '../../interfaces/inbox-job-filter';
import { IPageResult } from '../../interfaces/page-result';
import { CustomerInboxJobsService, UserService } from '../../services';
import { FilterStateService } from '../../services';
import { InboxBackService } from '../../services';
import { InboxJobsService } from '../../services';
import { BBWTMessageService } from '../../services';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Table, LazyLoadEvent, SelectItem } from 'primeng';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import moment from 'moment';

export enum CustomerInboxType {
  Unallocated = 1,
  Waiting = 2,
  Completed = 3,
  Closed = 5,
}

@Component({
  selector: 'customer-jobs-grid',
  templateUrl: './customer-jobs-grid.component.html',
  styleUrls: ['./jobs-inbox.scss', './customer-jobs-grid.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomerJobsGridComponent implements OnInit {
  private subscription: Subscription;

  public inboxType_Unallocated = 1;
  public inboxType_Waiting = 2;
  public inboxType_Completed = 3;
  public inboxType_Closed = 5;
  public inboxType_Cancelled = 6;
  public inboxType_GlobalFilter = 7;

  taskTypes: SelectItem[] = [this.inboxjobsService.taskTypeDefSelect];

  private readonly itemsPerPageDef = 20;
  private readonly defaultSortField = 'pickupLatest';
  private readonly defaultSortOrder = 1;
  private readonly reverseSortOrder = -1;

  public selectedJob: IInboxJob;

  @Output() jobSelectionChanged: EventEmitter<any>;
  @Output() onGridAction: EventEmitter<any>;

  private _inboxType: CustomerInboxType;
  @Input('inboxType')
  set inboxType(value: CustomerInboxType) {
    this._inboxType = value;
  }

  get inboxType(): CustomerInboxType {
    return this._inboxType;
  }

  public isLoaded: boolean = false;
  public loading: boolean = true;
  public page: IPageResult<IInboxJob> = {
    items: [],
    total: 0,
  };

  public filter: Subject<IInboxJobFilter>;
  public filterVal: IInboxJobFilter;

  constructor(
    private router: Router,
    private inboxjobsService: InboxJobsService,
    private customerInboxjobsService: CustomerInboxJobsService,
    public messageService: BBWTMessageService,
    private inboxBackService: InboxBackService,
    private filterStateService: FilterStateService,
    private userService: UserService,
  ) {
    this.jobSelectionChanged = new EventEmitter<any>();
    this.onGridAction = new EventEmitter<any>();
  }

  ngOnInit() {
    console.log('Customer GRID INITIALIZED...');

    if (
      this.filterStateService.inboxJobFilterVal &&
      this.filterStateService.inboxJobFilterVal.filters.inboxType.value == this.inboxType
    ) {
      this.filterVal = Object.assign({}, this.filterStateService.inboxJobFilterVal);
      this.filterStateService.inboxJobFilterVal = null;
    } else {
      this.initDefaultFilter();
    }

    this.inboxjobsService.bindTaskTypes().then((res) => (this.taskTypes = res));

    this.filter = new Subject<IInboxJobFilter>();

    // subscribe to filter changes with a debounce time
    this.subscription = this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);
    this.initRoles();
  }

  load(filter: IInboxJobFilter) {
    this.loading = true;

    this.customerInboxjobsService.getPage(filter).then((result) => {
      if (result.log) {
        console.log(`GRID RESPONSE LOG (inbox=${this.inboxType}):  `, result.log);
      }

      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
      this.loading = false;

      if (
        this.selectedJob != null &&
        this.page.items.find((o) => o.id == this.selectedJob.id) == null
      ) {
        this.deselectJob();
      }
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: this.itemsPerPageDef,
      sortField:
        this.inboxType == this.inboxType_Waiting || this.inboxType == this.inboxType_Unallocated
          ? 'scheduledDate'
          : this.inboxType == this.inboxType_Closed
          ? 'completedDate'
          : this.defaultSortField,
      sortOrder:
        this.inboxType == this.inboxType_Closed ? this.reverseSortOrder : this.defaultSortOrder,
      filters: {
        inboxType: { value: this._inboxType },
        from: { value: null },
        to: { value: null },
        taskType: { value: 0 },
        regNo: { value: null },
        closedDateFrom: { value: moment().subtract(1, 'months').toDate() },
        closedDateTo: { value: moment().toDate() },
        cancelledDateFrom: { value: moment().subtract(1, 'months').toDate() },
        cancelledDateTo: { value: moment().toDate() },
        completedDateFrom: { value: moment().subtract(1, 'months').toDate() },
        completedDateTo: { value: moment().toDate() },
      },
    };
  }

  onRowSelect(event) {
    this.jobSelectionChanged.emit([event.data, this.inboxType]);
  }

  deselectJobFromInbox() {
    this.selectedJob = null;
  }

  deselectJob() {
    this.selectedJob = null;
    this.jobSelectionChanged.emit([null, this.inboxType]);
  }

  itemsCountPostfix(item, value, count) {
    if (value == null || value == '' || count < 2) return value;
    return value + ' (+' + (count - 1) + ')';
  }

  tasksCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.tasksCount);
  }

  vehicleCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.vehiclesNum);
  }

  gridUpdate() {
    this.load(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);

    this.deselectJob();
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    this.initDefaultFilter();
    this.filter.next(this.filterVal);

    this.deselectJob();
  }

  //---- grid buttons -----
  jobScreen(item) {
    this.filterStateService.inboxJobFilterVal = this.filterVal;
    this.router.navigate(['app/jobscreen/' + item.id + '/' + item.orderId]);
  }

  editOrder(item) {
    this.router.navigate(['app/orderdetails/' + item.orderId]);
  }

  //---- /grid buttons -----

  showPriceDetails() {
    var param: any = {
      orderId: this.selectedJob.orderId,
    };

    this.router.navigate(['app/pricedetails'], { queryParams: param });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getDateFilterModel() {
    switch (this.inboxType) {
      case this.inboxType_Completed:
        return 'completed';
      case this.inboxType_Cancelled:
        return 'cancelled';
      case this.inboxType_Closed:
        return 'closed';
    }
  }

  protected hasCustomerBookingRole: boolean = false;
  protected hasCustomerPriceRole: boolean = false;
  private async initRoles() {
    this.hasCustomerBookingRole = await this.userService.isUserInRole('CUSTOMER_BOOKING');
    this.hasCustomerPriceRole = await this.userService.isUserInRole('CUSTOMER_PRICE');
  }
}
